import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({ ...props }) => (
  <Sonner
    theme="light"
    className="toaster group"
    closeButton
    richColors
    duration={5000}
    visibleToasts={5}
    expand
    gap={10}
    toastOptions={{
      classNames: {
        toast:
          "group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border-slate-200 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:p-3.5 group-[.toaster]:w-[356px] group-[.toaster]:max-w-[calc(100vw-32px)]",
        title: "group-[.toast]:text-[13px] group-[.toast]:font-semibold group-[.toast]:leading-snug",
        description:
          "group-[.toast]:text-[12px] group-[.toast]:text-slate-600 group-[.toast]:leading-relaxed group-[.toast]:whitespace-pre-wrap",
        actionButton:
          "group-[.toast]:bg-indigo-600 group-[.toast]:text-white",
        cancelButton:
          "group-[.toast]:bg-slate-100 group-[.toast]:text-slate-700",
        closeButton:
          "group-[.toast]:border-slate-200 group-[.toast]:bg-white group-[.toast]:text-slate-400 group-[.toast]:hover:bg-slate-100 group-[.toast]:hover:text-slate-700 group-[.toast]:top-3 group-[.toast]:right-3",
        success: "group-[.toaster]:border-emerald-200",
        error: "group-[.toaster]:border-rose-200",
        warning: "group-[.toaster]:border-amber-200",
        info: "group-[.toaster]:border-sky-200",
      },
    }}
    {...props}
  />
);

export { Toaster, toast };
